import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiHeart } from 'react-icons/fi';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col font-sans">
      <header className="py-4 px-6 lg:px-12 flex justify-between items-center bg-vintage-white/90 backdrop-blur-md sticky top-0 z-50 border-b border-warm-stone/20">
        <a href="/" className="flex items-center">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/8c3dc8994f71a85ad2d71f226c89cc7edce114857865647a461869cb9a6c120ffe2f6c628544606d61dcf48135de6ac8/images/aW1hZ2UvcG5n/49fbc51dedc141fb2ea20b58d0290b6e.png" 
            alt="Padua Weddings Logo" 
            className="h-16 md:h-20 w-auto object-contain mix-blend-multiply"
          />
        </a>
        <a 
          href="https://tour.paduaweddings.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-sm font-medium uppercase tracking-wider text-olive-grove hover:text-deep-charcoal transition-colors hidden sm:block"
        >
          Book a Private Tour
        </a>
      </header>

      <main className="flex-grow">
        {children}
      </main>

      <footer className="bg-deep-charcoal text-vintage-white py-12 px-6 lg:px-12 border-t border-white/10">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
          <a href="/" className="flex items-center">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/8c3dc8994f71a85ad2d71f226c89cc7edce114857865647a461869cb9a6c120ffe2f6c628544606d61dcf48135de6ac8/images/aW1hZ2UvcG5n/49fbc51dedc141fb2ea20b58d0290b6e.png" 
              alt="Padua Weddings Logo" 
              className="h-16 md:h-20 w-auto object-contain brightness-0 invert opacity-90"
            />
          </a>
          
          <div className="text-sm font-light text-vintage-white/60 flex items-center gap-1 text-center">
            Designed for romance <SafeIcon icon={FiHeart} className="w-3 h-3 text-estate-bronze inline mx-1" /> in Southern California
          </div>
          
          <div className="text-sm font-light text-vintage-white/40 text-center">
            © {new Date().getFullYear()} Padua Weddings. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;